import axios, { AxiosResponse } from 'axios';
import { IChatResponse } from 'interfaces/components/chatbot/chatbot';
export interface AskAIRequestBody {
  user_question: string;
  previous_response_id: string | null;
  email_id: string;
}

export const askAI = async (
  body: AskAIRequestBody
): Promise<IChatResponse> => {
  const response: AxiosResponse<IChatResponse> = await axios.post(
    '/api/askAI',
    body
  );



  return response.data;

};